/* Krautz Ironz – ki-zoom.js
 * Produktbild-Zoom für sections/ki-main-product.liquid:
 *  - Hover-Lupe auf dem Hauptbild (nur Maus/Trackpad), hochaufgelöstes Bild als Hintergrund
 *  - Lightbox mit allen Produktbildern: Pfeile/Tastatur, Wischen, Klick/Doppeltipp-Zoom, Pinch-Zoom, Mausrad, Verschieben
 * Liest nur [data-ki-zoom]-Roots und deren <script data-ki-zoom-media>; fasst ki-theme.js nicht an.
 * Welches Bild aktiv ist, wird über den markierten Thumbnail (.th.on, gesetzt von ki-theme.js) ermittelt.
 */
(function () {
  'use strict';
  if (window.KIZoom) return;

  var mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var MAX = 4, STEP = 2.5;

  var ICON = {
    close: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m15 5-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 5 7 7-7 7"/></svg>'
  };

  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function keyOf(url) { return String(url || '').split('?')[0].replace(/^https?:/, ''); }

  function currentIndex(root, media) {
    var on = root.querySelector('[data-ki-thumb].on, [data-ki-thumb][aria-current="true"]');
    if (on) {
      var id = String(on.getAttribute('data-ki-media-id'));
      for (var i = 0; i < media.length; i++) if (String(media[i].id) === id) return i;
    }
    var img = root.querySelector('[data-ki-main-image]');
    if (img) {
      var k = keyOf(img.currentSrc || img.src);
      for (var j = 0; j < media.length; j++) if (keyOf(media[j].src) === k || keyOf(media[j].zoom) === k) return j;
    }
    return 0;
  }

  /* ---------- Hover-Lupe ---------- */
  function initHover(root, main, media) {
    var factor = parseFloat(main.getAttribute('data-ki-zoom-factor')) || 2.2;
    var lens = null, active = false, raf = 0, lastE = null;

    function place() {
      var img = main.querySelector('[data-ki-main-image]');
      if (!img || !lens) return;
      /* Lupe deckt exakt die gerenderte Bildfläche ab (Bild ist object-fit:contain mit Innenabstand) */
      var cs = getComputedStyle(img);
      var pl = parseFloat(cs.paddingLeft) || 0, pt = parseFloat(cs.paddingTop) || 0;
      var boxW = img.clientWidth - pl - (parseFloat(cs.paddingRight) || 0);
      var boxH = img.clientHeight - pt - (parseFloat(cs.paddingBottom) || 0);
      var nw = img.naturalWidth || boxW, nh = img.naturalHeight || boxH;
      var s = Math.min(boxW / nw, boxH / nh);
      var w = nw * s, h = nh * s;
      lens.style.left = (img.offsetLeft + pl + (boxW - w) / 2) + 'px';
      lens.style.top = (img.offsetTop + pt + (boxH - h) / 2) + 'px';
      lens.style.width = w + 'px';
      lens.style.height = h + 'px';
      lens.style.backgroundSize = (w * factor) + 'px ' + (h * factor) + 'px';
    }
    function move() {
      raf = 0;
      if (!active || !lens || !lastE) return;
      var r = lens.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var x = Math.min(1, Math.max(0, (lastE.clientX - r.left) / r.width));
      var y = Math.min(1, Math.max(0, (lastE.clientY - r.top) / r.height));
      lens.style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
      main.classList.toggle('kz-on', lastE.clientX >= r.left && lastE.clientX <= r.right && lastE.clientY >= r.top && lastE.clientY <= r.bottom);
    }
    main.addEventListener('mouseenter', function (e) {
      if (!mqHover.matches || !media.length) return;
      var m = media[currentIndex(root, media)];
      if (!m) return;
      if (!lens) {
        lens = document.createElement('div');
        lens.className = 'kz-lens';
        lens.setAttribute('aria-hidden', 'true');
        main.appendChild(lens);
      }
      var url = m.zoom || m.src;
      if (lens.getAttribute('data-src') !== url) {
        lens.setAttribute('data-src', url);
        lens.style.backgroundImage = 'url("' + url.replace(/"/g, '%22') + '")';
      }
      active = true;
      place();
      lastE = e;
      move();
    });
    main.addEventListener('mousemove', function (e) {
      lastE = e;
      if (!raf) raf = requestAnimationFrame(move);
    });
    main.addEventListener('mouseleave', function () { active = false; main.classList.remove('kz-on'); });
  }

  /* ---------- Lightbox (eine Instanz für die Seite) ---------- */
  var box, stage, imgEl, counter, hint, prevBtn, nextBtn, closeBtn, live;
  var list = [], idx = 0, lastFocus = null, S = {};
  var scale = 1, tx = 0, ty = 0;
  var pointers = {}, gesture = null, lastTap = 0, moved = false, downOnImg = false;

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'kz-box';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML =
      '<div class="kz-stage" data-kz-stage><img class="kz-img" alt="" draggable="false" data-kz-img></div>' +
      '<button type="button" class="kz-btn kz-close" data-kz-close>' + ICON.close + '</button>' +
      '<button type="button" class="kz-btn kz-prev" data-kz-prev>' + ICON.prev + '</button>' +
      '<button type="button" class="kz-btn kz-next" data-kz-next>' + ICON.next + '</button>' +
      '<div class="kz-bar"><span class="kz-count" data-kz-count></span><span class="kz-hint" data-kz-hint></span></div>' +
      '<div class="kz-sr" aria-live="polite" data-kz-live></div>';
    document.body.appendChild(box);
    stage = box.querySelector('[data-kz-stage]');
    imgEl = box.querySelector('[data-kz-img]');
    counter = box.querySelector('[data-kz-count]');
    hint = box.querySelector('[data-kz-hint]');
    live = box.querySelector('[data-kz-live]');
    prevBtn = box.querySelector('[data-kz-prev]');
    nextBtn = box.querySelector('[data-kz-next]');
    closeBtn = box.querySelector('[data-kz-close]');

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
    box.addEventListener('keydown', onKey);
    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerup', onUp);
    stage.addEventListener('pointercancel', onUp);
    stage.addEventListener('wheel', onWheel, { passive: false });
    /* Klick auf den dunklen Hintergrund (nicht aufs Bild) schließt */
    stage.addEventListener('click', function () { if (!downOnImg && scale === 1 && !moved) close(); });
    imgEl.addEventListener('load', function () { box.classList.remove('kz-loading'); });
    window.addEventListener('resize', function () { if (!box.hidden) apply(); });
  }

  function labels() {
    box.setAttribute('aria-label', S.dialog || 'Bildansicht');
    closeBtn.setAttribute('aria-label', S.close || 'Schließen');
    prevBtn.setAttribute('aria-label', S.prev || 'Vorheriges Bild');
    nextBtn.setAttribute('aria-label', S.next || 'Nächstes Bild');
    hint.textContent = mqHover.matches ? (S.hint_desktop || '') : (S.hint_touch || '');
  }

  function bounds() {
    var w = imgEl.offsetWidth * scale, h = imgEl.offsetHeight * scale;
    return { x: Math.max(0, (w - stage.clientWidth) / 2), y: Math.max(0, (h - stage.clientHeight) / 2) };
  }
  function clamp() {
    var b = bounds();
    tx = Math.min(b.x, Math.max(-b.x, tx));
    ty = Math.min(b.y, Math.max(-b.y, ty));
  }
  function apply() {
    if (scale <= 1.001) { scale = 1; tx = 0; ty = 0; } else clamp();
    imgEl.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    box.classList.toggle('kz-zoomed', scale > 1);
  }
  /* Zoom so, dass der Punkt (cx,cy) im Viewport unter dem Finger/Cursor bleibt */
  function zoomAt(newScale, cx, cy) {
    newScale = Math.min(MAX, Math.max(1, newScale));
    var r = stage.getBoundingClientRect();
    var ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2);
    var k = newScale / scale;
    tx = ox - (ox - tx) * k;
    ty = oy - (oy - ty) * k;
    scale = newScale;
    apply();
  }
  function reset() { scale = 1; tx = 0; ty = 0; apply(); }

  function show(i) {
    if (!list.length) return;
    idx = (i + list.length) % list.length;
    var m = list[idx];
    reset();
    box.classList.add('kz-loading');
    imgEl.src = m.zoom || m.src;
    imgEl.alt = m.alt || '';
    if (m.w && m.h) { imgEl.width = m.w; imgEl.height = m.h; }
    var multi = list.length > 1;
    prevBtn.hidden = !multi; nextBtn.hidden = !multi;
    counter.textContent = multi ? (idx + 1) + ' / ' + list.length : '';
    live.textContent = (m.alt || '') + (multi ? ' – ' + (idx + 1) + ' / ' + list.length : '');
    /* Nachbarn vorladen */
    [idx + 1, idx - 1].forEach(function (n) {
      var nb = list[(n + list.length) % list.length];
      if (nb && nb !== m) { var p = new Image(); p.src = nb.zoom || nb.src; }
    });
  }
  function go(d) { if (list.length > 1) show(idx + d); }

  function open(media, start, strings, opener) {
    build();
    list = media; S = strings || {};
    labels();
    lastFocus = opener || document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add('kz-lock');
    show(start || 0);
    closeBtn.focus({ preventScroll: true });
  }
  function close() {
    if (!box || box.hidden) return;
    box.hidden = true;
    document.documentElement.classList.remove('kz-lock');
    imgEl.removeAttribute('src');
    pointers = {}; gesture = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); go(1); return; }
    if (e.key === '+' || e.key === '=') { e.preventDefault(); var r = stage.getBoundingClientRect(); zoomAt(scale * 1.5, r.left + r.width / 2, r.top + r.height / 2); return; }
    if (e.key === '-') { e.preventDefault(); var r2 = stage.getBoundingClientRect(); zoomAt(scale / 1.5, r2.left + r2.width / 2, r2.top + r2.height / 2); return; }
    if (e.key === 'Tab') {
      /* Fokus im Dialog halten */
      var f = Array.prototype.filter.call(box.querySelectorAll('button'), function (b) { return !b.hidden; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
  function onDown(e) {
    if (e.button && e.button !== 0) return;
    stage.setPointerCapture && stage.setPointerCapture(e.pointerId);
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);
    moved = false;
    downOnImg = e.target === imgEl;
    if (ids.length === 2) {
      var a = pointers[ids[0]], b = pointers[ids[1]];
      gesture = { type: 'pinch', d: dist(a, b) || 1, s: scale };
      box.classList.add('kz-pinching');
    } else if (ids.length === 1) {
      gesture = { type: scale > 1 ? 'pan' : 'swipe', x: e.clientX, y: e.clientY, tx: tx, ty: ty };
      if (scale > 1) box.classList.add('kz-dragging');
    }
  }
  function onMove(e) {
    if (!pointers[e.pointerId]) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    if (!gesture) return;
    if (gesture.type === 'pinch') {
      var ids = Object.keys(pointers);
      if (ids.length < 2) return;
      var a = pointers[ids[0]], b = pointers[ids[1]];
      zoomAt(gesture.s * (dist(a, b) / gesture.d), (a.x + b.x) / 2, (a.y + b.y) / 2);
      moved = true;
      return;
    }
    var dx = e.clientX - gesture.x, dy = e.clientY - gesture.y;
    if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
    if (gesture.type === 'pan') {
      tx = gesture.tx + dx; ty = gesture.ty + dy; apply();
    } else if (gesture.type === 'swipe' && list.length > 1) {
      imgEl.style.transform = 'translate(' + dx + 'px,0)';
    }
  }
  function onUp(e) {
    var p = pointers[e.pointerId];
    delete pointers[e.pointerId];
    var g = gesture;
    if (Object.keys(pointers).length) {
      /* von Pinch auf einen Finger: als Verschieben weitermachen */
      var rest = pointers[Object.keys(pointers)[0]];
      gesture = { type: 'pan', x: rest.x, y: rest.y, tx: tx, ty: ty };
      box.classList.remove('kz-pinching');
      return;
    }
    gesture = null;
    box.classList.remove('kz-dragging', 'kz-pinching');
    if (!g || !p || e.type === 'pointercancel') { apply(); return; }
    if (g.type === 'swipe') {
      var dx = e.clientX - g.x;
      if (moved && Math.abs(dx) > 50 && list.length > 1) { go(dx < 0 ? 1 : -1); return; }
      apply();
    }
    if (moved || !downOnImg) return;
    /* Tippen/Klicken aufs Bild: Maus = sofort umschalten, Touch = Doppeltipp */
    var now = Date.now();
    if (e.pointerType === 'mouse' || now - lastTap < 300) {
      lastTap = 0;
      if (scale > 1) reset(); else zoomAt(STEP, e.clientX, e.clientY);
    } else {
      lastTap = now;
    }
  }
  function onWheel(e) {
    e.preventDefault();
    var f = Math.exp(-e.deltaY * (e.deltaMode === 1 ? 0.05 : 0.0025));
    zoomAt(scale * f, e.clientX, e.clientY);
  }

  /* ---------- Init je Produkt-Section ---------- */
  function init(main) {
    if (main.__kz) return;
    main.__kz = true;
    var root = main.closest('[data-ki-product]') || main.parentNode;
    var media = readJSON(root, '[data-ki-zoom-media]') || [];
    var strings = readJSON(root, '[data-ki-zoom-strings]') || {};
    if (!media.length) return;
    if (main.getAttribute('data-ki-zoom-hover') === 'true') initHover(root, main, media);
    var btn = main.querySelector('[data-ki-zoom-open]');
    if (btn) btn.addEventListener('click', function () { open(media, currentIndex(root, media), strings, btn); });
  }
  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ki-zoom]'), init);
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { close(); boot(e.target); });

  window.KIZoom = { open: open, close: close, boot: boot };
})();
